import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-3a',
  templateUrl: 'app-3a-footer.component.html',
  styleUrls: ['app-3a-footer.component.scss'],
  standalone: false
})
export class App3aFooterComponent {}
